<app-header [label]="page_name | plural"></app-header>
<app-ag-grid-list [list]="items" [colDefs]="city_cols" [itemName]="page_name" (fetch_new_list)="get_list($event)"
  (bulkDelete)="bulk_delete($event)">
  <div toolbar class="flex gap-4 items-center justify-end mb-2">
    <app-button color="bg-secondary text-[#310000]" [label]="page_name" icon="bx bx-plus"
      (click)="open_form_modal()"></app-button>
  </div>
</app-ag-grid-list>
<app-confirmation-popup #delete_country_row label="Delete {{page_name}}?" [delete_icon]="true" cancelText="No"
  confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="Yes" [is_mandatory]="true"
  (confirm_modal_clicked)="delete_drive()" (close_modal_clicked)="delete_country_row.close()">
  This action cannot be undone, and all associated data will be permanently removed.
</app-confirmation-popup>
<app-modal #form_modal [label]="`${selected_drive_ids.id ? 'Update' : 'Add'} ${page_name}`">
  <form [formGroup]="form">
    <div class="py-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
      <app-text-input [is_required]="true" [type_total_latter]="10" class="w-full" [label]="page_name + ' Name'"
        formControlName="name"></app-text-input>
      <app-text-input [is_required]="true" [type_total_latter]="10" class="w-full" [label]="page_name + ' Code'"
        formControlName="code"></app-text-input>
      <app-select-input label="Academic Year" class="w-full" [is_required]="true" formControlName="academic_year_id"
        [options]="[]"></app-select-input>
      <app-select-input label="Status" class="w-full" [is_required]="true" formControlName="status"
        [options]="[]"></app-select-input>
    </div>
    <div class="flex justify-end items-center gap-2 mt-2">
      <app-button color="border-primary text-primary" label="Cancel" type="button"
        (click)="close_form_modal()"></app-button>
      <app-button color="bg-secondary text-black" [label]="selected_drive_ids.id ? 'Update' :'Add'" type="button"
        [submit]="submit.bind(this)"></app-button>
    </div>
  </form>
</app-modal>